import React from 'react'
import { useEffect, useState } from 'react'
import Header from '../../headertwo/Header'
import HeaderImage from '../../resources/images/tribunalstenth.JPG'
import { GrClose } from 'react-icons/gr'
import { getGalleryItems } from '../../../lib/strapi/phaseOneContent'
import './gallery.css'

const Gallery = () => {
  const [model, setModel] = useState(false)
  const [tempImgSrc, setTempImgSrc] = useState('')
  const [images, setImages] = useState([])

  const getImg = (image) => {
    setTempImgSrc(image)
    setModel(true)
  }

  useEffect(() => {
    const fallbackImages = Array.from({ length: 114 }, (_, index) => ({
      id: index + 1,
      image: require(`../../../tribunalimages/tribunal${index + 1}.JPG`),
    }));

    setImages(fallbackImages);

    let isMounted = true;

    async function loadGallery() {
      const nextImages = await getGalleryItems(fallbackImages);

      if (isMounted) {
        setImages(nextImages);
      }
    }

    loadGallery();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Header title="Gallery" image={HeaderImage}>
        Office Of The Registrar Tribunals Photos
      </Header>
      <div className={model ? "model open" : "model"}>
        <img src={tempImgSrc} alt="Gallery preview" />
        <GrClose onClick={() => setModel(false)} />
      </div>
      <section className="gallery">
        <div className="gallery_container">
          {
            images.map((image, index) => {
              return <div className='pic' key={image.id || index} onClick={() => getImg(image.image)}>
                <img src={image.image} alt={`Gallery item ${index + 1}`} />
              </div>
            })
          }
        </div>
      </section>
    </>
  )
}

export default Gallery  
